var option_default = {
  "option": "tpe7E",
  "user_choice": "tx1Yb",
  "check": "Yb9ZL",
  "image": "yB2K8",
  "input": "rpKC9",
  "title": "_6agQP",
  "centered": "Yo8wx",
  "with_result": "_9YCH3",
  "list": "k4I7n",
  "with_image": "h7UU3",
  "progress": "I1sPD",
  "progress_value": "_7wnG3",
  "label": "E1x1-",
  "cta": "grsVi",
  "adornment_icon": "_2Q0Z5",
  "remove": "X8g-h",
  "removeButton": "pbMGU",
  "removeButtonIcon": "Neu8y",
  "overlay": "yjyrx",
  "shown": "jTByB",
  "dark": "XWRz8",
  "spinner": "pZ86b",
  "spin": "ELGRr"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
